/**
 * @author yan st
 * @date 2025-10-31 08:37
 * @Description:
 */
import {get, qspost} from '@/plugins/axios'

/*
* 首页
* */
export const getHomeIndex = () => get('/api/admin/index', {

})

/*
* 首页
* */
export const getHomeWarningIndex = (level) => get('/api/admin/index/warning', {
  level
})

/*
* 首页
* */
export const getHomeStarsIndex = (star_id) => get('/api/admin/index/stars', {
  star_id
})

/*
* 机构列表
* */
export const org_lst = (org_name,license,jianguan,is_lock,peixun_lei,status,page, limit) => qspost('/api/admin/org/org_lst', {
  org_name,license,jianguan,is_lock,peixun_lei,status,page, limit
})

/*
* 机构导出
* */
export const org_export = (org_name,license,jianguan,is_lock,peixun_lei,status,) => qspost('/api/admin/org/export', {
  org_name,license,jianguan,is_lock,peixun_lei,status,
})


/*
* 闭店/开启
* */
export const setOrgLock = (org_id,lock,reason = '') => qspost('/api/admin/org/set_lock', {
  org_id,lock,reason
})

/*
* 闭店/开启
* */
export const sendOrgMsg = (org_id,message) => qspost('/api/admin/org/send_msg', {
  org_id,message
})



/*
* 获取 机构信息 - 基础信息
* */
export const get_base_info = (org_id) => get('/api/admin/org/get_base_info?org_id=' + org_id, {

})

/*
* 机构信息 - 基础信息 - 上半部分
* */
export const save_base = (
  org_id,logo,use_address,floor,lease_contract_start,lease_contract_end,lease_contract,area,build_date,apprenticeship_contract,
  apprenticeship_contract_files,contract_use_model,institutional_situation,chengnuoshu
) => qspost('/api/admin/org/save_base', {
  org_id,logo,use_address,floor,lease_contract_start,lease_contract_end,lease_contract,area,build_date,apprenticeship_contract,
  apprenticeship_contract_files,contract_use_model,institutional_situation,chengnuoshu
})

/*
* 机构信息 - 基础信息 - 下半部分
* */
export const save_check = (
  org_id,org_name,zhuce_ziben,shijiao_ziben, is_faren_banxue,brand,have_group, group,is_reg,is_license_able,
  xuke_no,xuke_zhucedi,xuke_con,xuke_set_date,xuke_date,
  fire_safes,is_stock_org,org_code,reg_address
) => qspost('/api/admin/org/save_check', {
  org_id,org_name,zhuce_ziben,shijiao_ziben, is_faren_banxue,brand,have_group, group,is_reg,is_license_able,
  xuke_no,xuke_zhucedi,xuke_con,xuke_set_date,xuke_date,
  fire_safes,is_stock_org,org_code,reg_address
})

/*
* 保存 资金监管信息
* */
export const save_zijin = (
  org_id,is_kaili,shoufei_bank,shoufei_account,shoufei_number,kaihuming,zhang_hao,kai_hu_hang,yue,is_kaili_fengxian,
  kaihuming_fengxian,zhang_hao_fengxian,kai_hu_hang_fengxian,yue_fengxian
) => qspost('/api/admin/org/save_zijin', {
  org_id,is_kaili,shoufei_bank,shoufei_account,shoufei_number,kaihuming,zhang_hao,kai_hu_hang,yue,is_kaili_fengxian,
  kaihuming_fengxian,zhang_hao_fengxian,kai_hu_hang_fengxian,yue_fengxian
})

/*
* 获取资金监管信息
* */
export const zijin = (org_id) => get('/api/admin/org/zijin?org_id=' + org_id, {

})


/*
* 预收资金添加修改（每月10日之前）
* */
export const save_yushou = (org_id,id,yushou,file,type = '') => qspost('/api/admin/org/save_yushou', {
  org_id, id,yushou,file,type
})

/*
* 预收资金列表
* */
export const yushou = (org_id,page,limit) => qspost('/api/admin/org/yushou', {
  org_id,page,limit
})

/*
* 预收资金列表
* */
export const del_yushou = (org_id,id) => qspost('/api/admin/org/del_yushou', {
  org_id,id
})

/*
* 机构运营 获取详情
* type : 1 党建信息2联系人信息3课程教材4教学开展5安全管理7行业促进
* */
export const get_yunying = (
  org_id,type
) => get(`/api/admin/org/get_yunying?org_id=${org_id}&type=${type}`, {

})

/*
* 党的建设信息
* */
export const save_dangyuan = (
  org_id,dagnyuan_num,is_build_zuzhi,build_type,lishu_guanxi,lishu_guanxi_other,is_naru_zhangcheng,zhangcheng
) => qspost('/api/admin/org/save_dangyuan', {
  org_id,dagnyuan_num,is_build_zuzhi,build_type,lishu_guanxi,lishu_guanxi_other,is_naru_zhangcheng,zhangcheng
})

/*
* 联系人信息
* */
export const save_contact = (
  org_id,faren_name,faren_idcard,faren_phone,fuzeren_name,fuzeren_idcard,fuzeren_phone,
  kongzhi_name,kongzhi_idcard,kongzhi_phone,gdList
) => qspost('/api/admin/org/save_contact', {
  org_id,faren_name,faren_idcard,faren_phone,fuzeren_name,fuzeren_idcard,fuzeren_phone,
  kongzhi_name,kongzhi_idcard,kongzhi_phone,gdList
})

/*
* 联系人信息股东
* */
export const save_gudong = (
  org_id,gdList
) => qspost('/api/admin/org/gudong', {
  org_id,gdList
})

/*
* 课程教材信息保存
* */
export const save_classes = (
  org_id,peixun_lei,peixun_qita,ksList
) => qspost('/api/admin/org/save_classes', {
  org_id,peixun_lei,peixun_qita,ksList
})

/*
* 课程教材信息保存教材
* */
export const save_jiaocai = (
  org_id,jcList
) => qspost('/api/admin/org/save_jiaocai', {
  org_id,jcList
})

/*
* 获取月末学员情况详情
* */
export const get_xueyuan = (
  org_id,id
) => get(`/api/admin/org/get_xueyuan?org_id=${org_id}&id=${id}`, {

})

/*
* 获取月末学员情况保存
* */
export const save_xueyuan = (
  org_id,student_num,money,file,class_num,id
) => qspost('/api/admin/org/save_xueyuan', {
  org_id,student_num,money,file,class_num,id
})

/*
* 教学开展信息保存
* */
export const save_jiaoxue = (
  org_id,is_cansai,cansai_name,is_yanxue,quyu,qita_saishi_name
) => qspost('/api/admin/org/save_jiaoxue', {
  org_id,is_cansai,cansai_name,is_yanxue,quyu,qita_saishi_name
})

/*
* 月末学员列表
* */
export const xueyuan_lst = (
  org_id,page,limit
) => qspost('/api/admin/org/xueyuan_lst', {
  org_id,page,limit
})

/*
* 删除月末在册学员
* */
export const del_xueyuan = (
  org_id,id
) => qspost('/api/admin/org/del_xueyuan', {
  org_id,id
})

/*
* 安全管理信息保存
* */
export const save_anquan = (
  org_id,is_qianan,is_zicha,last_yan_lian,zu_zhi,an_images
) => qspost('/api/admin/org/save_anquan', {
  org_id,is_qianan,is_zicha,last_yan_lian,zu_zhi,an_images
})

/*
* 行业促进信息保存
* */
export const save_cujin = (
  org_id,huzhu,chengjie_lv,huodong_lv,zhengfu_rongyu
) => qspost('/api/admin/org/save_cujin', {
  org_id,huzhu,chengjie_lv,huodong_lv,zhengfu_rongyu
})

/*
* 员工档案信息保存
* */
export const save_employ = (
  org_id,id,name,leixing,card_type,idcard,phone,have_zhengming,zhengming,pin_type,have_hetong,hetong,jiaoshi_zizhi
) => qspost('/api/admin/org/save_employ', {
  org_id,id,name,leixing,card_type,idcard,phone,have_zhengming,zhengming,pin_type,have_hetong,hetong,jiaoshi_zizhi
})

/*
* 获取员工档案详情
* */
export const get_employ = (
  org_id,id
) => get(`/api/admin/org/get_employ?org_id=${org_id}&id=${id}`, {

})

/*
* 员工档案列表
* */
export const employ_lst = (
  org_id,page,limit
) => qspost('/api/admin/org/employ_lst', {
  org_id,page,limit
})

/*
* 删除员工
* */
export const del_employ = (
  org_id,id
) => qspost('/api/admin/org/del_employ', {
  org_id,id
})


/*
* 监管信息添加
* */
export const save_jian = (
  org_id,id,do_date,jiancha_name,zijin_cunguan_is_gs,hetong_is_gs,price_is_gs,zhizhao_is_gs,jubaophone_is_gs,
  teachers_is_gs,tuifei_is_gs,anquan_is_hegui,anquan_wenti,anquan_is_zhenggai,yinhuan_is_exist,
  yinhuan,yinhuan_is_zhenggai,shigu_is_exist,shigu,xiaofang_dengji,other,is_zhenggai,zhenggai_time,
  zhenggai_content,is_wancheng_zhenggai,zhenggai_qing_file,is_yuetan,yuetan_time,yuetan_ren,
  yuetan_content,yuetan_file,leiji_tousu_year,leiji_tousu_month,leiji_tousu_wei,is_biangeng,biangeng_con,
  is_baingeng_beian,weibeian,tsList
) => qspost('/api/admin/org/save_jian', {
  org_id,id,do_date,jiancha_name,zijin_cunguan_is_gs,hetong_is_gs,price_is_gs,zhizhao_is_gs,jubaophone_is_gs,
  teachers_is_gs,tuifei_is_gs,anquan_is_hegui,anquan_wenti,anquan_is_zhenggai,yinhuan_is_exist,
  yinhuan,yinhuan_is_zhenggai,shigu_is_exist,shigu,xiaofang_dengji,other,is_zhenggai,zhenggai_time,
  zhenggai_content,is_wancheng_zhenggai,zhenggai_qing_file,is_yuetan,yuetan_time,yuetan_ren,
  yuetan_content,yuetan_file,leiji_tousu_year,leiji_tousu_month,leiji_tousu_wei,is_biangeng,biangeng_con,
  is_baingeng_beian,weibeian,tsList
})

/*
* 监管信息详情
* */
export const get_jian = (
  org_id,id
) => get(`/api/admin/org/get_jian?org_id=${org_id}&id=${id}`, {

})


/*
* 监管信息列表
* */
export const jian_lst = (
  org_id,page,limit
) => qspost('/api/admin/org/jian_lst', {
  org_id,page,limit
})

/*
* 监管信息列表删除
* */
export const del_jian = (
  id
) => qspost('/api/admin/org/del_jian', {
  id
})

/*
* 风险信息保存
* */
export const save_feng = (
  org_id,id,biangeng_con,is_jingying_yichang,jingying_yichang,is_shuiwu_yichang,shuiwu_yichang,shixin_con,
  laodong_jiufen,qianxian_jiufen,shebao_jiufen,fangzu_jiufen,is_zijin,zijin_qingkuang,is_zijin_dae,
  zijin_dae_qingkuang,is_yuqing,yuqing_qingkuang,weigui_con,is_shesu,shesu_con,is_zhongda_yinhuan,
  zhongda_yinhuan,other,is_zijinfengxian,zijin_jianguan_fengxian,pingtai_loubao,loubao_qingkuang,
  is_yishi,yishi_wenti
) => qspost('/api/admin/org/save_feng', {
  org_id,id,biangeng_con,is_jingying_yichang,jingying_yichang,is_shuiwu_yichang,shuiwu_yichang,shixin_con,
  laodong_jiufen,qianxian_jiufen,shebao_jiufen,fangzu_jiufen,is_zijin,zijin_qingkuang,is_zijin_dae,
  zijin_dae_qingkuang,is_yuqing,yuqing_qingkuang,weigui_con,is_shesu,shesu_con,is_zhongda_yinhuan,
  zhongda_yinhuan,other,is_zijinfengxian,zijin_jianguan_fengxian,pingtai_loubao,loubao_qingkuang,
  is_yishi,yishi_wenti
})


/*
* 风险信息详情
* */
export const get_feng = (
  org_id,id
) => get(`/api/admin/org/get_feng?org_id=${org_id}&id=${id}`, {

})

/*
* 风险信息列表
* */
export const feng_lst = (
  org_id,page,limit
) => qspost('/api/admin/org/feng_lst', {
  org_id,page,limit
})


/*
* 审核内容列表
* */
export const shenhe_lst = (model,org_id,page, limit) => qspost('/api/admin/org/shenhe_lst', {
  model,org_id,page, limit
})


/*
* 机构信息审核
* */
export const shenheOrgInfo = (id,remark,status) => qspost('/api/admin/org/shenhe', {
  id,remark,status
})

/*
* 星级评定列表
* */
export const getEvaluateList = (keyword,time,status,page, limit) => qspost('/api/admin/star/lst', {
  keyword,time,status,page, limit
})

/*
* 添加星级评定
* */
export const addEvaluate = (id,title,message,start_time,end_time) => qspost('/api/admin/star/save', {
  id,title,message,start_time,end_time
})

/*
* 星级评定详情
* */
export const getEvaluateDetail = (id) => get('/api/admin/star/detail', {
  id
})


/*
* 删除星级评定
* */
export const delEvaluate = (id) => get('/api/admin/star/del', {
  id
})

/*
* 星级评定详情-统计
* */
export const getEvaluationTotal = (id) => get('/api/admin/star/org_num', {
  id
})

/*
* 星级评定详情-机构列表
* */
export const getEvaluateOrgList = (id,keyword,is_warning,star,score1,score2,page, limit) => qspost('/api/admin/star/org_lst', {
  id,keyword,is_warning,star,score1,score2,page, limit
})

/*
* 星级评定详情-打分详情
* */
export const getEvaluateOrgDetail = (org_id, star_id) => qspost('/api/admin/star/org_detail', {
  org_id, star_id
})

/*
* 星级评定列表
* */
export const getEvaluateStarList = (org_id,keyword,time,is_can,star,page, limit) => qspost('/api/admin/star/star_lst', {
  org_id,keyword,time,is_can,star,page, limit
})


/*
* 星级评定详情-打分详情
* */
export const getEvaluateOrgReport = (org_id, id) => qspost('/api/admin/star/baogao', {
  org_id, id
})


/*
* 预警统计
* */
export const getWarningStatistics = () => get('/api/admin/warning/statistics', {

})

/*
* 信息列表 模块1政策法规2通知公告3宣传信息4下载中心
* */
export const getArticleList = (keyword,cid,page, limit) => qspost('/api/admin/article/lst', {
  keyword,cid,page, limit
})

/*
* 保存内容
* */
export const saveArticle = (is_show,id,title,desc,cid,is_top,is_tui,status,thumb,content,files,
                            reid,author,resource,publish_time) => qspost('/api/admin/article/save', {
  is_show,id,title,desc,cid,is_top,is_tui,status,thumb,content,files,
  reid,author,resource,publish_time
})

/*
* 详情
* */
export const getArticleDetail = (id) => get('/api/admin/article/detail', {
  id
})

/*
* 设置（排序，状态，置顶，推荐） 1排序2置顶3推荐4状态
* */
export const setArticle = (id,mode,value) => qspost('/api/admin/article/set', {
    id,mode,value
})

/*
* 删除内容
* */
export const delArticle = (id) => get('/api/admin/article/del', {
    id
})

/*
* 宣传列表
* */
export const getPromoteList = (keyword,page, limit) => qspost('/api/admin/promote/lst', {
  keyword,page, limit
})

/*
* 宣传采纳
* */
export const promotecai = (id,cai) => get(`/api/admin/promote/cai?id=${id}&cai=${cai}`, {

})



/*
* 宣传详情
* */
export const getPromoteDetail = (id) => get('/api/admin/promote/detail', {
    id
})

/*
* 下载分类列表
* */
export const getCatArticleList = (page, limit) => qspost('/api/admin/article/cat_lst', {
  page, limit
})

/*
* 下载编辑
* */
export const addCatArticle = (id,name) => qspost('/api/admin/article/save_cat', {
    id,name
})

/*
* 删除分类
* */
export const delCatArticle = (id) => get('/api/admin/article/del_cat', {
    id
})

/*
* 问题反馈列表
* */
export const getQuestionList = (keyword,page, limit) => qspost('/api/admin/article/connect', {
  keyword,page, limit
})

/*
* 申诉列表
* */
export const getObjectionAppealList = (keyword,status,page, limit) => qspost('/api/admin/star/shensu', {
  keyword,status,page, limit
})

/*
* 申诉列表
* */
export const setObjectionAppealState = (id,status, file,remark) => qspost('/api/admin/star/set_status', {
  id,status, file,remark
})

/*
* 持证教培机构/开通监管账户机构列表
* */
export const getArticleOrgList = (keyword,type,page, limit) => qspost('/api/admin/article/org_lst', {
  keyword,type,page, limit
})

/*
* 保存机构
* */
export const addArticleOrg = (id,type, org_name) => qspost('/api/admin/article/save_org', {
  id,type, org_name
})

/*
* 删除机构
* */
export const delArticleOrg = (id) => get('/api/admin/article/del_org', {
  id
})

/*
* 账号列表
* */
export const getAccountList = (keyword,page, limit) => qspost('/api/admin/account/lst', {
  keyword,page, limit
})

/*
* 新建/修改账号
* */
export const addAccount = (id,username, password) => qspost('/api/admin/account/save', {
  id,username, password
})

/*
* 删除账号
* */
export const delAccount = (id) => get('/api/admin/account/del', {
  id
})

/*
* 预警列表
* */
export const getWarningList = (keyword,time,level,status,page, limit) => qspost('/api/admin/warning/lst', {
  keyword,time,level,status,page, limit
})

/*
* 预警列表导出
* */
export const getWarningListExport = (keyword,time,level,status) => qspost('/api/admin/warning/export', {
  keyword,time,level,status
})

/*
* 添加预警
* */
export const addWarning = (org_id,level,info,information,status,is_queren,cailiao) => qspost('/api/admin/warning/add', {
  org_id,level,info,information,status,is_queren,cailiao
})

/*
* 预警详情
* */
export const getWarningDetail = (id) => get('/api/admin/warning/detail', {
  id
})

/*
* 督办
* */
export const dubanWarning = (id,due_date) => qspost('/api/admin/warning/duban', {
  id,due_date
})

/*
* 预警审核
* */
export const shenheWarning = (id,change) => qspost('/api/admin/warning/shenhe', {
  id,change
})

/*
* 操作记录的账号筛选列表
* */
export const getLogAccount = () => get('/api/admin/account/log_account', {

})

/*
* 预警列表
* */
export const getLogList = (keyword,admin_id,time,model_id,page, limit) => qspost('/api/admin/log', {
  keyword,admin_id,time,model_id,page, limit
})


/*
* 修改密码
* */
export const edit_pass = (old_pass,new_pass) => qspost('/api/admin/account/edit_pass', {
  old_pass,new_pass
})





























